/**
 * Census 2020 percent urban population — county-level lookup.
 * Generated by data_raw/build_urban.R from the Census Bureau's county-level
 * 2020 Census urban-rural file (2020_UA_COUNTY.xlsx).
 *
 * Value: percent of county population living in 2020 Census urban areas,
 * 0–100 with 1 decimal (already converted from the source file's 0–1
 * proportion). Continuous; higher = more urban.
 *
 * KNOWN GAP: the source uses legacy Connecticut counties (09001–09015) while
 * the app keys on CT planning regions (09110–09190), so CT resolves as
 * unavailable — same precedent as the IRR county file.
 *
 * Display/comparison only — NOT a composite input.
 *
 * Source:  https://www.census.gov/programs-surveys/geography/guidance/geo-areas/urban-rural.html
 * License: Public domain (US federal work, 17 U.S.C. § 105)
 */

let _data = null;
let _loadPromise = null;

export function loadUrbanData() {
  if (_data) return Promise.resolve();
  if (_loadPromise) return _loadPromise;
  _loadPromise = fetch(`${process.env.PUBLIC_URL}/data/urban.json`)
    .then(r => {
      if (!r.ok) throw new Error(`Failed to load urban data (${r.status})`);
      return r.json();
    })
    .then(d => { _data = d; _loadPromise = null; })
    .catch(err => { _loadPromise = null; throw err; });
  return _loadPromise;
}

export function getUrbanPctForCounty(stateFips, countyFips) {
  if (!_data) return null;
  const key = `${String(stateFips).padStart(2, "0")}${String(countyFips).padStart(3, "0")}`;
  const v = _data[key];
  return typeof v === "number" ? v : null;
}

const urban = { loadUrbanData, getUrbanPctForCounty };
export default urban;
